'use client';

import React, { useState } from 'react';
import { ProductType } from '@/@types';
import { Button, Card, Icon, Link } from '@/components/core';
import { Trans } from '@lingui/react/macro';
import Comment from '@/components/core/components/organism/comment';
import { useUser } from '@/components/context/user';
import { useDownloadApp } from '@/components/core/components/organism/download-app-modal/download-app-modal';
import { paginationToArray } from '@/services/api/namespaces/_utils';
import * as styles from './comments.styles';

const Comments: React.FC<{ product: ProductType }> = ({ product }) => {
  const { isLogged } = useUser();
  const [total, setTotal] = useState(5);
  const downloadApp = useDownloadApp();
  const comments = paginationToArray(product.recommendations);
  return (
    <div className={styles.root}>
      <Card className={styles.root}>
        <div className="flex items-center justify-between">
          <span className={styles.title}>
            <Trans>Comments</Trans>
          </span>
          {isLogged && (
            <Link as="span" className={styles.addComment}>
              <Trans>Add Comment</Trans>
            </Link>
          )}
        </div>
        {product.recommendations.total === 0 && (
          <div className={styles.noComments}>
            <span>
              <Trans>Be the first to add a comment</Trans>
            </span>
            <Button
              variant="borderless"
              className={styles.firstCommentBtn}
              onClick={() => {
                downloadApp('default');
              }}
            >
              <span>
                <Trans>Add Comment</Trans>
              </span>
              <Icon name="comments" />
            </Button>
          </div>
        )}
        <ul className={styles.comments}>
          {comments.slice(0, total).map((comment) => {
            return <Comment className={styles.comment} comment={comment} key={comment.id} />;
          })}
        </ul>
      </Card>
      {comments.length > 5 && total !== comments.length && (
        <Button
          onClick={() => {
            setTotal(comments.length);
          }}
          variant="primary"
          className={styles.moreComments}
        >
          <Trans>See more comments</Trans>
        </Button>
      )}
    </div>
  );
};

export default Comments;
